import React, { useState, useEffect } from 'react';
import { Result, Button, Card, Space, Typography, Divider, message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined } from '@ant-design/icons';

import { Order } from '../../types';
import { formatAmount, formatDateTime } from '../../utils';

const { Text } = Typography;

const PaymentComplete: React.FC = () => {


  const [order, setOrder] = useState<Order | null>(null);
  const [success, setSuccess] = useState<boolean>(false); // Assuming default to false

  useEffect(() => {
    const storedOrder = sessionStorage.getItem('currentOrder');
    const storedSuccess = sessionStorage.getItem('paymentSuccess'); 

    if (storedOrder) {
      setOrder(JSON.parse(storedOrder));
      setSuccess(storedSuccess === 'true'); // Convert string to boolean
    } else {
      message.error('支付信息丢失，请联系客服');
      // Optionally close the window or navigate to a specific error page
      // window.close(); 
    }
  }, []);

  // 生成交易流水号
  const transactionNo = 'TXN' + Date.now();

  useEffect(() => {
    // 可以在这里添加支付完成后的逻辑，比如发送通知等
    if (order && success) {
      console.log('支付成功，订单号：', order.order_no);
    } else if (order && !success) {
      console.log('支付失败，订单号：', order.order_no);
    }
  }, [success, order]);

  if (!order) {
    return (
      <div className="empty-container">
        <Text>支付信息丢失，请联系客服</Text>
        <Button 
          type="primary" 
          onClick={() => window.close()} // Close the window if order is lost
          style={{ marginTop: 16 }}
        >
          关闭页面
        </Button>
      </div>
    );
  }

  const handleViewTransactions = () => {
    // 新标签页打开账单查询页面
    window.open('/#/transactions', '_blank');
  };

  const handleNewPayment = () => {
    window.close(); // Close the window
  };

  const handleBackHome = () => {
    // 新标签页打开订单中心
    window.open('about:blank', '_blank');
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '40px 20px' }}>
      {success ? (
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          status="success"
          title="支付成功！"
          subTitle={`交易已完成，感谢您使用交e保支付服务`}
          extra={[
            <Button type="primary" key="transactions" onClick={handleViewTransactions} size="large" style={{ minWidth: 140 }}>
              查看交易记录
            </Button>,
            <Button key="home" icon={<HomeOutlined />} onClick={handleBackHome} size="large" style={{ minWidth: 140 }}>
              返回订单中心
            </Button>,
          ]}
        />
      ) : (
        <Result
          icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
          status="error"
          title="支付失败"
          subTitle="很抱歉，本次支付未能成功完成，请重试或联系客服"
          extra={[
            <Button type="primary" key="retry" onClick={handleNewPayment} size="large" style={{ minWidth: 140 }}>
              重新支付
            </Button>,
            <Button key="home" onClick={handleBackHome} size="large" style={{ minWidth: 140 }}>
              返回订单中心
            </Button>,
          ]}
        />
      )}

      {/* 交易详情卡片 */}
      <Card 
        title="交易详情" 
        style={{ marginTop: 24 }}
        headStyle={{ background: '#fafafa', fontWeight: 600 }}
      >
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">订单号：</Text>
            <Text strong>{order.order_no}</Text>
          </div>
          
          {success && (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Text type="secondary">交易流水号：</Text>
              <Text strong>{transactionNo}</Text>
            </div>
          )}
          

          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">付款方：</Text>
            <Text>{order.payer_name}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">收款方：</Text>
            <Text>{order.payee_name}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">支付方式：</Text>
            <Text>交e保支付</Text>
          </div>
          
          <Divider />
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">支付金额：</Text>
            <Text 
              strong 
              style={{ 
                fontSize: 18, 
                color: success ? '#52c41a' : '#ff4d4f',
                fontFamily: 'monospace'
              }}
            >
              ¥{formatAmount(order.amount)}
            </Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">交易时间：</Text>
            <Text>{formatDateTime(new Date().toISOString())}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">交易状态：</Text>
            <Text style={{ color: success ? '#52c41a' : '#ff4d4f' }}>
              {success ? '成功' : '失败'}
            </Text>
          </div>
        </Space>
      </Card>



      {!success && (
        <>
        </>
      )}
    </div>
  );
};

export default PaymentComplete;